/**
 * Cart event utilities for Magento integration
 */

/**
 * Dispatch Magento event to refresh cart and open minicart
 */
export function dispatchCartRefreshEvent(): void {
  document.dispatchEvent(new CustomEvent('specialCartEventPopup', {}));
}
